import { Link } from 'react-router-dom';
import logo from '../assets/imgs/anniversario.webp';
import text from '../assets/imgs/logo-header-text.webp';
import '../styles/footer.scss';
import { MENU } from '../configs/header';
import { MapPin } from 'lucide-react';

const Footer = () => {
  return <>
  <div className='border-footer' />
  <footer className='w-full text-white'>
    <div className='bg-footer' />
    <div className='flex flex-col lg:flex-row p-5 pb-12 xl:p-12 lg:mx-12 max-w-7xl xl:mx-auto'>
      <div className='flex flex-col basis-1/4 gap-5'>
        <div className='flex items-center'>
          <img src={logo} width={60} height={60} alt='ACI 6 logo' className='max-w-[unset]' loading="lazy" decoding="async" />
          <img src={text} width={280} height={70} alt='Acireale 6' className='max-w-[unset] -translate-x-6' loading="lazy" decoding="async" />
        </div>
        <div className='flex'>
          <MapPin className='mr-3 mt-2' color='white' />
          <a className='text-xl text-white hover:underline' rel="noreferrer" target='_blank' href='https://maps.app.goo.gl/DiWri6CYAsUpKNuc9'>
            Via Lombardia 14C <br /> Acireale (CT) 95024
          </a>
        </div>
      </div>
      {MENU.filter(m => m.footer).map(menu =>
        <div key={menu.text.replace(' ', '_')} className='flex flex-col basis-1/4 gap-5'>
          <h2 className='font-cream text-xl mt-10 lg:mt-0'>{menu.text}</h2>
          <div className='flex flex-col gap-4'>
            {menu.items.map(item => <Link key={item.text.replace(' ', '_')} className='text-xl font-poppins hover:underline' to={item.link}>{item.text}</Link>)}
          </div>
        </div>)}
    </div>
    <p className='absolute bottom-2 left-4 text-gray-600 font-poppins'>Copyright &copy; {new Date().getFullYear()} Gruppo Scout Acireale 6</p>
  </footer>
  </>
}

export default Footer;